import { render, staticRenderFns } from "./ChildBirthdayStep.vue?vue&type=template&id=78363304"
import script from "./ChildBirthdayStep.vue?vue&type=script&lang=js"
export * from "./ChildBirthdayStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports